/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const EnableMonitoringIntegrationHeaders = zod.object({
  'x-csrf-token': zod.string(),
  'Idempotency-Key': zod.string(),
});

export type EnableMonitoringIntegrationHeaders = zod.input<
  typeof EnableMonitoringIntegrationHeaders
>;
export type EnableMonitoringIntegrationHeadersOutput = zod.output<
  typeof EnableMonitoringIntegrationHeaders
>;
